import { Coordinates } from "@/types";

export const makeCircleSlices = (colors: string[], svgElement: HTMLElement | null) => {
    if (!svgElement) return
    const viewBoxSize = 200;
    const padding = 20;

    const centerX = viewBoxSize / 2;
    const centerY = viewBoxSize / 2;
    const radius = (viewBoxSize / 2) - padding;

    const slices = colors.length
    const hasOnlyOneSlice = slices == 1
    const strokeWidth = "6"
    const strokeColor = "white"

    function polarToCartesian(cx: any, cy: any, r: any, angleDeg: any) {
        const angleRad = (angleDeg - 90) * Math.PI / 180.0;
        return {
            x: cx + r * Math.cos(angleRad),
            y: cy + r * Math.sin(angleRad)
        };
    }

    function describeSlice(cx: any, cy: any, r: any, startAngle: any, endAngle: any) {
        const start = polarToCartesian(cx, cy, r, startAngle);
        const end = polarToCartesian(cx, cy, r, endAngle);
        const largeArcFlag = (endAngle - startAngle) > 180 ? 1 : 0;

        return [
            `M ${cx} ${cy}`,
            `L ${start.x} ${start.y}`,
            `A ${r} ${r} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
            `Z`
        ].join(" ");
    }

    function makeSlicePath(index: number) {

        const startAngle = (360 / slices) * index;
        const endAngle = (360 / slices) * (index + 1);
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        const sliceColor = colors[index]
        path.setAttribute("d", describeSlice(centerX, centerY, radius, startAngle, endAngle));
        path.setAttribute("fill", sliceColor);
        path.setAttribute("stroke", strokeColor)
        path.setAttribute("stroke-width", strokeWidth)
        return path
    }

    function makeFullCircle() {
        const color = colors[0]
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", `${centerX}`);
        circle.setAttribute("cy", `${centerY}`);
        circle.setAttribute("fill", `${color}`);
        circle.setAttribute("stroke", strokeColor)
        circle.setAttribute("r", `${radius}`)
        circle.setAttribute("stroke-width", strokeWidth)
        return circle
    }
    if (hasOnlyOneSlice) {
        return svgElement.appendChild(makeFullCircle())
    }

    for (let i = 0; i < slices; i++) {
        svgElement.appendChild(makeSlicePath(i));
    }
}


export function assureType<T>(value: T): value is NonNullable<T> {
    return value != null
}

export const keepOnlyNumbers = (str: string): string => str.replace(/[^\d]/g, '');
export const limitString = (text: string, limit: number = 20): string => text?.length >= limit ? `${text.substr(0, limit - 1)}...` : text
export const capitalizeFirst = (text: string): string => text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : ''
export const numberToCurrency = (value: number): string => {
    try {
        return `R$${Number(value)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            .replace(/,/g, "*")
            .replace(/\./g, ",")
            .replace(/\*/g, ".")}`;
    } catch (e) {
        return `${value}`
    }
}

export const calculateDistance = (coords1: { lat: number, lng: number }, coords2: { lat: number, lng: number }): number => {
    const R = 6371000;
    const toRad = (grau: number) => grau * Math.PI / 180;
    const dLat = toRad(coords2.lat - coords1.lat);
    const dLng = toRad(coords2.lng - coords1.lng);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(coords1.lat)) * Math.cos(toRad(coords2.lat)) * Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
export const getFixedAmount = (value: number | string, decimals: number = 0): number => {
    if (!value) return 0
    if (typeof value == 'string') {
        value = Number(value)
    }
    return Number((value || 0).toFixed(decimals))
}